import { render, staticRenderFns } from "./BEditorActions.vue?vue&type=template&id=0501899e&"
import script from "./BEditorActions.vue?vue&type=script&lang=js&"
export * from "./BEditorActions.vue?vue&type=script&lang=js&"
import style0 from "./BEditorActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports